// extracted by mini-css-extract-plugin
export default {"pagination-status":"pagination-status","paginationStatus":"pagination-status"};